var _symbol, _symbol2, _symbol3, _symbol4, _symbol5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#103b9b",
    style: {
      fill: "var(--color1, #103b9b)"
    },
    d: "M0.455 0.455h31.089v31.089h-31.089v-31.089z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M17.036 9.782c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M13.928 10.615c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M11.651 12.891c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M10.818 16c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M11.651 19.109c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M13.928 21.385c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M17.036 22.218c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M20.145 21.385c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M22.421 19.109c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M23.254 16c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M22.421 12.891c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    style: {
      fill: "var(--color2, #ffe000)"
    },
    d: "M20.145 10.615c0 0.572-0.464 1.036-1.036 1.036s-1.036-0.464-1.036-1.036c0-0.572 0.464-1.036 1.036-1.036s1.036 0.464 1.036 1.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color3, #000)"
    },
    d: "M31.545 32h-31.089c-0.252 0-0.455-0.204-0.455-0.455v-6.218c0-0.252 0.204-0.455 0.455-0.455s0.455 0.204 0.455 0.455v5.762h30.178v-30.178h-30.178v21.307c0 0.252-0.204 0.455-0.455 0.455s-0.455-0.204-0.455-0.455v-21.762c0-0.252 0.204-0.455 0.455-0.455h31.089c0.252 0 0.455 0.204 0.455 0.455v31.089c0 0.252-0.204 0.455-0.455 0.455z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-usa",
    viewBox: "0 0 35 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    style: {
      fill: "var(--color4, #d8d8d8)"
    },
    d: "M-53.333-360h581.333v453.333h-581.333v-453.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc4437",
    style: {
      fill: "var(--color5, #dc4437)"
    },
    d: "M0 0h34.667v3.547h-34.667v-3.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc4437",
    style: {
      fill: "var(--color5, #dc4437)"
    },
    d: "M0 7.12h34.667v3.547h-34.667v-3.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc4437",
    style: {
      fill: "var(--color5, #dc4437)"
    },
    d: "M0 21.333h34.667v3.547h-34.667v-3.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc4437",
    style: {
      fill: "var(--color5, #dc4437)"
    },
    d: "M0 28.453h34.667v3.547h-34.667v-3.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc4437",
    style: {
      fill: "var(--color5, #dc4437)"
    },
    d: "M0 14.213h34.667v3.547h-34.667v-3.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M0 3.547h34.667v3.547h-34.667v-3.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M0 10.667h34.667v3.547h-34.667v-3.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M0 24.88h34.667v3.547h-34.667v-3.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M0 17.787h34.667v3.547h-34.667v-3.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a66b7",
    style: {
      fill: "var(--color7, #2a66b7)"
    },
    d: "M0 0h18.667v17.787h-18.667v-17.787z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M3.6 1.067l0.613 1.307 1.387 0.213-1.013 1.040 0.24 1.44-1.227-0.693-1.227 0.693 0.24-1.44-1.013-1.040 1.387-0.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M9.067 1.067l0.613 1.307 1.387 0.213-0.987 1.040 0.213 1.44-1.227-0.693-1.227 0.693 0.213-1.44-0.987-1.040 1.387-0.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M14.533 1.067l0.613 1.307 1.387 0.213-1.013 1.040 0.24 1.44-1.227-0.693-1.227 0.693 0.24-1.44-1.013-1.040 1.387-0.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M6.4 6.4l0.613 1.307 1.387 0.213-0.987 1.040 0.213 1.44-1.227-0.693-1.227 0.693 0.213-1.44-0.987-1.040 1.387-0.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M11.867 6.4l0.613 1.307 1.387 0.213-1.013 1.040 0.24 1.44-1.227-0.693-1.227 0.693 0.24-1.44-1.013-1.040 1.387-0.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M3.6 12.053l0.613 1.307 1.387 0.213-1.013 1.013 0.24 1.467-1.227-0.693-1.227 0.693 0.24-1.467-1.013-1.013 1.387-0.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M9.067 12.053l0.613 1.307 1.387 0.213-0.987 1.013 0.213 1.467-1.227-0.693-1.227 0.693 0.213-1.467-0.987-1.013 1.387-0.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color6, #fff)"
    },
    d: "M14.533 12.053l0.613 1.307 1.387 0.213-1.013 1.013 0.24 1.467-1.227-0.693-1.227 0.693 0.24-1.467-1.013-1.013 1.387-0.213z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-hryvnia",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.21 5c-0.99 0-1.948 0.29-2.773 0.84l-1.992 1.328 1.11 1.664 1.992-1.328c0.467-0.316 1.042-0.504 1.661-0.504 0.001 0 0.001 0 0.002 0h4.385c1.327 0.003 2.403 1.079 2.403 2.407 0 0.74-0.334 1.402-0.86 1.844l-0.004 0.003-0.894 0.746h-11.24v2h8.84l-3.602 3h-5.238v2h2.84l-0.254 0.21c-0.972 0.812-1.586 2.025-1.586 3.382 0 0.002 0 0.004 0 0.006v-0c0.003 2.431 1.973 4.4 4.404 4.403h4.385c0.99 0 1.95-0.29 2.773-0.84l1.993-1.328-1.11-1.664-1.992 1.328c-0.467 0.316-1.042 0.504-1.661 0.504-0.001 0-0.001 0-0.002 0h-4.385c-1.327-0.003-2.403-1.079-2.403-2.407 0-0.74 0.334-1.402 0.86-1.844l0.004-0.003 2.095-1.746h10.039v-2h-7.639l3.6-3h4.039v-2h-1.85c0.531-0.717 0.85-1.619 0.85-2.596v0c-0.003-2.431-1.973-4.401-4.404-4.404h-4.386z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-euro",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.335 29.793c-3.405 0-6.174-2.77-6.174-6.174v-3.741h11.767v-2.207h-11.767v-2.943h11.767v-2.207h-11.767v-4.14c0-3.405 2.77-6.174 6.174-6.174s6.174 2.77 6.174 6.174h2.207c0-4.621-3.76-8.381-8.381-8.381s-8.381 3.76-8.381 8.381v4.14h-2.575v2.207h2.575v2.943h-2.669v2.207h2.669v3.741c0 4.621 3.76 8.381 8.381 8.381s8.381-3.76 8.381-8.381h-2.207c-0 3.405-2.77 6.174-6.174 6.174z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-coins",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.633 4.99c0-2.797-4.342-4.99-9.885-4.99-4.615 0-8.462 1.495-9.574 3.719l-0.066 0.129 0.145-0.007c0.263-0.014 0.544-0.021 0.857-0.025h0.044l0.025-0.035c1.208-1.7 4.732-2.889 8.568-2.889 4.875 0 8.993 1.876 8.993 4.097 0 1.959-3.358 3.739-7.642 4.050l-0.080 0.005v0.894l0.092-0.005c3.414-0.228 6.239-1.281 7.631-2.834v1.313c0 1.429 0 4.774-7.641 5.109l-0.081 0.003v0.891l0.090-0.003c3.826-0.168 6.39-1.101 7.632-2.776v0.952c0 1.428 0 4.773-7.641 5.107l-0.081 0.003v0.891l0.090-0.003c3.824-0.166 6.39-1.101 7.632-2.776v0.954c0 1.428 0 4.774-7.641 5.107l-0.081 0.003v0.892l0.090-0.005c3.826-0.166 6.391-1.1 7.632-2.776v1.283c0 1.44 0 4.813-7.779 5.112l-0.065 0.003-0.014 0.064c-0.064 0.277-0.142 0.517-0.239 0.747l0.011-0.029-0.051 0.122 0.133-0.003c8.896-0.269 8.896-4.444 8.896-6.015v-3.509h-0.046c0.046-0.393 0.046-0.737 0.046-0.995v-3.509h-0.015c0.015-0.261 0.015-0.493 0.015-0.666v-3.424l-0.017-0.066c0.017-0.269 0.017-0.507 0.017-0.685v-3.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.251 4.534c-5.541 0-9.883 2.193-9.883 4.99v3.425c0 0.201 0.002 0.418 0.019 0.666h-0.020v3.507c0 0.202 0.002 0.421 0.019 0.668h-0.019v3.507c0 0.254 0 0.597 0.051 0.995h-0.051v3.509c0 1.532 0 6.198 9.95 6.198 9.816 0 9.816-4.504 9.816-6.198v-3.509h-0.044c0.044-0.39 0.044-0.737 0.044-0.995v-3.507h-0.014c0.014-0.261 0.014-0.495 0.014-0.668v-3.507h-0.014c0.014-0.261 0.014-0.493 0.014-0.666v-3.425c0-2.797-4.341-4.99-9.882-4.99zM11.251 13.622c-4.873 0-8.991-1.876-8.991-4.098s4.117-4.097 8.991-4.097 8.993 1.876 8.993 4.097c0 2.222-4.12 4.098-8.993 4.098zM11.318 18.086c-9.058 0-9.058-3.732-9.058-5.137v-1.315c1.578 1.756 5.066 2.88 8.991 2.88s7.413-1.124 8.993-2.88v1.315c0 1.536 0 5.137-8.926 5.137zM11.318 22.259c-9.058 0-9.058-3.732-9.058-5.137v-1.032c1.406 1.916 4.452 2.885 9.058 2.885 4.545 0 7.545-0.943 8.925-2.806v0.952c0 1.538 0 5.137-8.925 5.137zM11.318 26.435c-9.058 0-9.058-3.732-9.058-5.136v-1.032c1.406 1.915 4.452 2.886 9.058 2.886 4.545 0 7.545-0.944 8.925-2.806v0.952c0 1.537 0 5.136-8.925 5.136zM11.318 31.109c-9.058 0-9.058-3.856-9.058-5.306v-1.363c1.406 1.915 4.452 2.887 9.058 2.887 4.545 0 7.545-0.944 8.925-2.806v1.281c0 1.588 0 5.306-8.925 5.306z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.628 7.427l-1.14 0.386c-0.562-0.135-1.175-0.205-1.772-0.205-0.672 0-1.288 0.088-1.781 0.254-0.465 0.156-0.7 0.338-0.739 0.569-0.041 0.246 0.146 0.514 0.609 0.871 0.23 0.184 0.336 0.327 0.32 0.427-0.012 0.069-0.098 0.173-0.433 0.286-0.297 0.099-0.655 0.152-1.039 0.152-0.447 0-0.898-0.071-1.299-0.207-0.535-0.18-0.944-0.431-1.092-0.675l-0.028-0.048-1.203 0.191 0.051 0.104c0.113 0.23 0.507 0.491 1.048 0.707l-1.147 0.385 0.981 0.331 1.185-0.398c1.241 0.301 2.779 0.272 3.746-0.055 0.535-0.178 0.806-0.378 0.85-0.629 0.041-0.233-0.123-0.489-0.514-0.802-0.193-0.161-0.443-0.387-0.42-0.516 0.014-0.074 0.133-0.148 0.35-0.223 0.193-0.064 0.509-0.141 0.931-0.141 0.38 0 0.762 0.063 1.135 0.189 0.712 0.24 0.901 0.475 0.993 0.589l0.032 0.037 1.23-0.185-0.096-0.117c-0.173-0.208-0.466-0.396-0.892-0.571l1.116-0.376-0.982-0.331zM18.601 3.55l0.18-0.115-1.117-0.221-0.028 0.016c-0.284 0.162-0.451 0.438-0.443 0.724l-1.283-0.077 0.104 0.495 1.343 0.082c0.397 0.612 1.52 0.887 2.374 0.938 0.135 0.007 0.261 0.011 0.383 0.011 0.868 0 1.415-0.205 1.827-0.688 0.38-0.422 0.661-0.523 1.249-0.484 0.246 0.014 1.050 0.094 1.136 0.507 0.053 0.246-0.101 0.399-0.276 0.53l-0.151 0.113 1.089 0.223 0.032-0.023c0.23-0.175 0.341-0.377 0.341-0.613l1.249 0.077-0.106-0.495-1.292-0.080c-0.325-0.479-1.2-0.826-2.251-0.89-0.093-0.007-0.202-0.010-0.313-0.011h-0c-0.828 0-1.363 0.224-1.786 0.747-0.293 0.343-0.675 0.465-1.324 0.422-0.709-0.043-1.226-0.276-1.293-0.582-0.064-0.304 0.226-0.525 0.353-0.607z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dollar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.219 15.684l-1.249-0.395v-11.322c2.527 0.459 4.45 2.674 4.45 5.331h1.939c0-3.729-2.788-6.819-6.389-7.295v-2.003h-1.939v2.003c-3.601 0.476-6.389 3.566-6.389 7.295 0 3.529 1.777 5.956 5.14 7.018l1.249 0.395v11.322c-2.527-0.459-4.45-2.674-4.45-5.331h-1.939c0 3.729 2.788 6.819 6.389 7.295v2.003h1.939v-2.003c3.601-0.476 6.389-3.566 6.389-7.295 0-3.529-1.777-5.956-5.14-7.018zM14.365 14.467c-2.582-0.816-3.785-2.458-3.785-5.169 0-2.657 1.923-4.872 4.45-5.331v10.709l-0.665-0.21zM16.97 28.033v-10.709l0.665 0.21c2.582 0.816 3.785 2.458 3.785 5.169 0 2.657-1.923 4.872-4.45 5.331z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrows",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.645 22.549l-9.751-6.832c-0.143-0.1-0.282-0.153-0.437-0.153-0.335 0-0.657 0.255-0.657 0.742v4.165h-18.783c-0.503 0-0.898 0.419-0.898 0.923v3.608c0 0.503 0.395 0.948 0.898 0.948h18.783v4.14c0 0.487 0.321 0.729 0.657 0.729h-0.009c0.155 0 0.308-0.047 0.451-0.147l9.748-6.828c0.225-0.157 0.352-0.392 0.352-0.647s-0.13-0.49-0.355-0.647zM10.558 16.449c0.211 0 0.42-0.097 0.545-0.267 0.095-0.129 0.161-0.293 0.161-0.475v-4.165h18.715c0.503 0 0.865-0.419 0.865-0.923v-3.608c0-0.503-0.361-0.948-0.865-0.948h-18.715v-4.14c0-0.487-0.355-0.742-0.691-0.742-0.155 0-0.32 0.053-0.463 0.153l-9.755 6.831c-0.225 0.157-0.355 0.394-0.355 0.648s0.128 0.491 0.352 0.648l9.751 6.832c0.143 0.1 0.3 0.153 0.455 0.153z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.61c2644d5b54eb4e4df3a619d0e56c7d.svg";
export { ForwardRef as ReactComponent };